import Big from 'big.js';

// Configure Big.js globally
export const initializeBigJs = () => {
  Big.DP = 2; // 2 decimal places
  Big.RM = 1; // Rounding mode: 1 = round to nearest, ties to even

  if (import.meta.env.VITE_NODE_ENV === 'local') {
    console.log('Big.js configured with DP=2, RM=1');
  }
};
